import API from 'utils/api';
import getFormattedValues from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';

export const baseURL = 'nominas/motivos-de-retenciones-de-pagos';

const getValuesAndConfig = (values) => {
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  };
  const formattedValues = getFormattedValues(values, {
    formData: config.headers,
    clean: false,
  });
  return [formattedValues, config];
};

export const getMotivosRetencionDePagos = async (params) => {
  try {
    const response = await API.get(baseURL, { params });
    return response.data;
  } catch (error) {
    onError(error);
    return [];
  }
};

export const getMotivoRetencionDePago = async (id) => {
  try {
    const response = await API.get(`${baseURL}/${id}`);
    return await response.data;
  } catch (error) {
    onError(error);
    return null;
  }
};

export const postMotivoRetencionDePago = async (values) => {
  try {
    const response = await API.post(baseURL, ...getValuesAndConfig(values));
    onSuccess(response, 'Agregado correctamente.');
    return response.data;
  } catch (error) {
    onError(error);
    return false;
  }
};

export const patchMotivoRetencionDePago = async (id, values) => {
  try {
    const response = await API.patch(`${baseURL}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (error) {
    onError(error);
    return false;
  }
};

export const deleteMotivoRetencionDePago = async (id) => {
  try {
    const response = await API.delete(`${baseURL}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (error) {
    onError(error);
    return false;
  }
};
